"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");

var sportnet_utilities_1 = require("sportnet-utilities");

var styled_components_1 = __importDefault(require("styled-components"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var utilities_2 = require("../../utilities");

var Header_1 = __importDefault(require("../../components/Header"));

var List_1 = __importDefault(require("./List"));

var Slider_1 = __importDefault(require("./Slider"));

var Tiles_1 = __importDefault(require("./Tiles"));

var MOBILE_BREAKPOINT = 'xs';
exports.ARTICLE_LIST_DISPLAY = {
  TILES: {
    id: 'tiles',
    label: 'Dlaždice'
  },
  LIST: {
    id: 'list',
    label: 'Zoznam'
  },
  LIST_WITHOUT_PICTURES: {
    id: 'list_without_pictures',
    label: 'Zoznam bez obrázkov'
  }
};
var StyledSlider = styled_components_1["default"](Slider_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  ", " {\n    display: none !important;\n  }\n"], ["\n  display: block;\n  ", " {\n    display: none !important;\n  }\n"])), utilities_1.mb(MOBILE_BREAKPOINT));
var StyledTiles = styled_components_1["default"](Tiles_1["default"])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: none;\n  padding: 0 ", "px;\n  ", " {\n    display: grid;\n  }\n"], ["\n  display: none;\n  padding: 0 ", "px;\n  ", " {\n    display: grid;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.app.padding;
}, utilities_1.mb(MOBILE_BREAKPOINT));
var StyledHeader = styled_components_1["default"](Header_1["default"])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 0 ", "px;\n"], ["\n  padding: 0 ", "px;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.app.padding;
});

var C = function C(_a) {
  var renderLink = _a.renderLink,
      renderEmpty = _a.renderEmpty,
      data = _a.data,
      _b = _a.data,
      _c = _b.header,
      header = _c === void 0 ? '' : _c,
      _d = _b.display,
      display = _d === void 0 ? exports.ARTICLE_LIST_DISPLAY.LIST.id : _d,
      _e = _b.data,
      _f = _b.articleFilter,
      articleFilter = _f === void 0 ? [] : _f;
  var articles = sportnet_utilities_1.getProp(data, ['data', 'articleFilter', 'articles'], []);

  if (!articles.length && renderEmpty) {
    return renderEmpty(data.type);
  }

  function render() {
    switch (display) {
      case exports.ARTICLE_LIST_DISPLAY.TILES.id:
        return react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(StyledSlider, {
          articles: articles,
          renderLink: renderLink
        }), react_1["default"].createElement(StyledTiles, {
          articles: articles,
          renderLink: renderLink
        }));

      case exports.ARTICLE_LIST_DISPLAY.LIST.id:
        return react_1["default"].createElement(List_1["default"], {
          articles: articles,
          renderLink: renderLink
        });

      case exports.ARTICLE_LIST_DISPLAY.LIST_WITHOUT_PICTURES.id:
        return react_1["default"].createElement(List_1["default"], {
          articles: articles,
          renderLink: renderLink,
          showPicture: false
        });
    }

    return null;
  }

  return react_1["default"].createElement(react_1["default"].Fragment, null, header && react_1["default"].createElement(StyledHeader, {
    renderShowmoreLink: function renderShowmoreLink(linkProps) {
      return renderLink({
        type: utilities_2.WIDGET_LINK_TYPE.ARTICLE_FILTER,
        payload: {
          filter: articleFilter,
          header: header
        },
        linkProps: linkProps
      });
    }
  }, header), render());
};

C.propTypes = {
  data: prop_types_1["default"].shape({
    header: prop_types_1["default"].string,
    display: prop_types_1["default"].arrayOf(Object.values(exports.ARTICLE_LIST_DISPLAY).map(function (d) {
      return d.id;
    })),
    articleFilter: prop_types_1["default"].array
  }),
  renderLink: prop_types_1["default"].func.isRequired,
  renderEmpty: prop_types_1["default"].func
};
C.defaultProps = {
  data: {}
};
exports["default"] = C;
var templateObject_1, templateObject_2, templateObject_3;